import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Typography, Box, Button } from "@material-ui/core/"
import logo from "../../assets/firstline_social_icon_logo.png"
import { useHistory } from "react-router-dom"

const NotFound = ({ classes }) => {
  let history = useHistory()
  // console.log(history)
  const openFeed = () => {
    history.push("/app/feed")
  }
  return (
    <Box
      className={classes.notFoundContainer}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box className={classes.logoContainer}>
        <img src={logo} alt="First Social Logo" className={classes.logo} />
      </Box>
      <Box className={classes.textContainer}>
        <Typography className={classes.notFoundNumbers}>404</Typography>
        <Typography variant="subtitle2" className={classes.notFoundText}>
          Sorry, we couldn't find the page you're looking for.
        </Typography>
        <Button
          variant="contained"
          onClick={openFeed}
          className={classes.backButton}
        >
          Go back
        </Button>
      </Box>
    </Box>
  )
}

export default withStyles(styles)(NotFound)



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.jsx